export type VineProfileState = 'connected' | 'not_on_vine' | 'not_connected';

export interface VineProfileUser {
  userId: number;
  uniqueId: string;
  displayName: string;
}

export interface VineProfileLabels {
  message: string;
  inviteToVine: string;
  connect: string;
  loading: string;
}

export interface LaunchOneOnOneHandler {
  (friendId: number, introduction: string, loginId: string): void;
}

export interface JoinMeetingOptions {
  enablePreBreakout?: boolean;
}

export interface IdigestChatHostConfig {
  /** Optional host-owned message region; omitted preserves the existing chat. */
  renderMessageList?: (props: any) => import('react').ReactNode;
  profileMode: 'idigest' | 'vine';
  vineProfileLabels?: VineProfileLabels;
  resolveVineProfileState?: (user: VineProfileUser) => Promise<VineProfileState>;
  onVineMessage?: (user: VineProfileUser) => void | Promise<void>;
  onVineInvite?: (user: VineProfileUser) => void | Promise<void>;
  onVineConnect?: (user: VineProfileUser) => void | Promise<void>;
  /** Host opens the online meeting window for a group. Falls back to package openMeeting when omitted. */
  onJoinMeeting?: (groupId: number, opts?: JoinMeetingOptions) => void | Promise<void>;
}

let hostConfig: IdigestChatHostConfig = { profileMode: 'idigest' };
let launchOneOnOneHandler: LaunchOneOnOneHandler | null = null;

export function setIdigestChatHostConfig(config: Partial<IdigestChatHostConfig>) {
  hostConfig = { ...hostConfig, ...config };
}

export function getIdigestChatHostConfig(): IdigestChatHostConfig {
  return hostConfig;
}

export function resetIdigestChatHostConfig() {
  hostConfig = { profileMode: 'idigest' };
  launchOneOnOneHandler = null;
}

export function registerLaunchOneOnOneHandler(handler: LaunchOneOnOneHandler) {
  launchOneOnOneHandler = handler;
}

export function getLaunchOneOnOneHandler(): LaunchOneOnOneHandler | null {
  return launchOneOnOneHandler;
}
